export default {
  toasts: {
    failed_to_create_website: 'Verkkosivun luominen epäonnistui',
  },
  steps: {
    information: 'Tiedot',
    template: 'Malli',
  },
  buttons: {
    next: 'Seuraava',
    previous: 'Edellinen',
    create_website: 'Luo verkkosivu',
    preview_about_us: 'Meistä (esikatselu)',
  },
  about_us_modal: {
    title: 'Meistä (esikatselu)',
  },
  error_messages: {
    missing_fields: 'Joitakin pakollisia kenttiä puuttuu. Täytä kaikki tarvittavat tiedot ennen jatkamista.',
  },
};
